import React from 'react';
import {
  BEHAVIOUR_OPTIONS,
  DATA_TYPE_OPTIONS,
  FINANCIAL_CLASSIFICATIONS,
  suggestFieldCode,
} from '../../adapters';

const GeneralTab = ({ field, sections, readOnly, onChange, onCodeChange, isDraft }) => {
  const cfg = field.metadata?.businessConfig || {};
  const patchCfg = (patch) => onChange({
    metadata: {
      ...(field.metadata || {}),
      businessConfig: { ...cfg, ...patch },
    },
  });

  return (
    <div className="ra-tpl-tab-body">
      <div className="form-group">
        <label>Field Name</label>
        <input
          disabled={readOnly}
          value={field.fieldLabel || ''}
          onChange={(e) => {
            const label = e.target.value;
            const patch = { fieldLabel: label };
            if (isDraft && !field._codeTouched) {
              patch.fieldCode = suggestFieldCode(label) || field.fieldCode;
            }
            onChange(patch);
            if (patch.fieldCode && patch.fieldCode !== field.fieldCode) {
              onCodeChange(patch.fieldCode);
            }
          }}
        />
      </div>
      <div className="form-row">
        <div className="form-group">
          <label>Line / Reference</label>
          <input
            disabled={readOnly}
            value={cfg.lineReference || ''}
            onChange={(e) => patchCfg({ lineReference: e.target.value })}
            placeholder="e.g. 2(a) or b)"
          />
        </div>
        <div className="form-group">
          <label>Field Code</label>
          <input
            disabled={readOnly || !isDraft}
            value={field.fieldCode || ''}
            onChange={(e) => {
              onChange({ _codeTouched: true });
              onCodeChange(e.target.value);
            }}
          />
          <p className="ra-tpl-help">Permanent internal identity used by calculations. Editable only while Draft.</p>
        </div>
      </div>
      <div className="form-group">
        <label>Section</label>
        <select
          disabled={readOnly}
          value={field.sectionCode || ''}
          onChange={(e) => onChange({ sectionCode: e.target.value })}
        >
          {(sections || []).map((s) => (
            <option key={s.sectionCode} value={s.sectionCode}>{s.sectionName}</option>
          ))}
        </select>
      </div>
      <div className="form-row">
        <div className="form-group">
          <label>Data Type</label>
          <select disabled={readOnly} value={field.dataType || 'AMOUNT'} onChange={(e) => onChange({ dataType: e.target.value })}>
            {DATA_TYPE_OPTIONS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
          </select>
        </div>
        <div className="form-group">
          <label>Field Behaviour</label>
          <select
            disabled={readOnly}
            value={cfg.behaviourType || 'MANUAL_ENTRY'}
            onChange={(e) => patchCfg({ behaviourType: e.target.value })}
          >
            {BEHAVIOUR_OPTIONS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
          </select>
        </div>
      </div>
      <div className="form-group">
        <label>Financial Classification</label>
        <select
          disabled={readOnly}
          value={cfg.financialClassification || 'REFERENCE'}
          onChange={(e) => patchCfg({ financialClassification: e.target.value })}
        >
          {FINANCIAL_CLASSIFICATIONS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
        </select>
        <p className="ra-tpl-help">Business category — not the same as System Meaning.</p>
      </div>
    </div>
  );
};

export default GeneralTab;
